module.exports = __webpack_public_path__ + "img/recommended_01.0e82d5de.webp";